<cs-header>
  <cs-header-title>{{ LL.training.changeWorkout.title() }}</cs-header-title>
  <div class="description">{{ LL.training.changeWorkout.description() }}</div>
</cs-header>

<cs-content [loading]="loading">
  <cs-radio-group [(selected)]="selectedPlanReference">
    @for (workout of workoutOptions; track workout) {
      <cs-radio [value]="workout.planReference" [default]="workout.isDefault">
        {{ workout.name }}
        <cs-note>{{ workout.exerciseNames }}</cs-note>
      </cs-radio>
    }
  </cs-radio-group>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="cancel($event)">
  <cs-button medium primary [label]="LL.common.buttons.save()" (click)="save()"></cs-button>
</cs-page-action-buttons>